export default {
  mainColor: '#0D2551',
  yellowish: '#ffcc00',
  disabledButton: '#333'
};
